import React from 'react';
import { Route, Switch, useRouteMatch } from "react-router-dom";
import TeacherAssignments from "./TeacherAssignments";
import UploadedAssignments from "./UploadedAssignments";
import SubmittedAssignments from "./SubmittedAssignments";
import GradeAssignment from './GradeAssignment';

function TeacherHomeWork() {
  let { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={TeacherAssignments} />
      <Route path={`${path}/uploaded-assignments`} component={UploadedAssignments} />
      <Route path={`${path}/submitted-assignments`} component={SubmittedAssignments} />
      <Route path={`${path}/grade-assignment/:link`} component={GradeAssignment} />
    </Switch>
  );
}

export default TeacherHomeWork;